import styled, { css } from 'styled-components'
import { Row } from '@sainsburys-tech/bolt'
import { remCalculator, colorToLunaToken } from '../../../helpers/theming/utilities'
import { NectarHeading, TextWrapper, dropShadowCSS, LinkWrapper } from '../../../helpers/StyledWrappers.styles'
import { C004StyledWrapper } from './types'

const wrapperCSS = css<C004StyledWrapper>`
  ${dropShadowCSS}
  ${(props) =>
    css`
      border: ${props.theme.size.border.width.sm} solid ${colorToLunaToken(props.borderColor, props.theme)};
      border-radius: ${props.theme.size.border.radius.base};
      margin-bottom: ${remCalculator(props.theme.size.spacing.lg)};
      ${props.theme.channel === 'sainsburys' &&
      props.hasOnLinkClick &&
      css`
        :hover {
          cursor: pointer;
        }
      `}
    `}
`

const containerCSS = css<C004StyledWrapper>`
  ${dropShadowCSS}
  margin-bottom: ${(props) => remCalculator(props.theme.size.spacing.lg)};
  text-decoration: none;
  display: flex;
  width: 100%;
  height: calc(100% - 16px);
  align-content: flex-start;
`

export const StyledWrapperMain = styled(Row)`
  ${wrapperCSS}
  ${TextWrapper}
  ${(props) =>
    props.theme.channel === 'sainsburys' &&
    css`
      ${LinkWrapper}
    `}
  min-height: 210px;
  background-color: ${(props) => props.theme.color.monochrome.white};
  color: ${(props) => colorToLunaToken(props.textColor, props.theme)};
  justify-content: center;
  padding: ${(props) => props.theme.size.spacing.xl};
`
export const StyledWrapperWithLogo = styled(Row)`
  ${wrapperCSS}
`
export const StyledHeadingWrapper = styled.h3`
  ${NectarHeading}
  && {
    margin: 0;
  }
`
export const StyledHeadingCtaWrapper = styled.h3`
  && {
    margin-bottom: ${(props) => remCalculator(props.theme.size.spacing.lg)};
    ${NectarHeading}
  }
`

export const StyledContainer = styled.a`
  ${containerCSS}
`
